import { render, staticRenderFns } from "./TransacModal.vue?vue&type=template&id=5875779a"
import script from "./TransacModal.vue?vue&type=script&lang=js"
export * from "./TransacModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports